"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appointmentStatus = appointmentStatus;
exports.callPatientWaitingRoom = callPatientWaitingRoom;
exports.deleteDocument = deleteDocument;
exports.getDocuments = getDocuments;
exports.getQuestions = getQuestions;
exports.getQuestionsAnswer = getQuestionsAnswer;
exports.postAnswers = postAnswers;
exports.sendCallEndDuration = sendCallEndDuration;
exports.submitDocuments = submitDocuments;
exports.updateDocument = updateDocument;
exports.uploadDocument = uploadDocument;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getQuestions(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_QUESTIONARIE;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getQuestionsAnswer(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_QUESTIONARIE_ANS + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function postAnswers(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.POST_QUESTIONAIRE;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function getDocuments(params, tokenData) {
  let apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_DOCUMENTS;
  let queryString = '?';
  for (const key in params) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + params[key];
    } else {
      queryString = queryString + '&' + key + '=' + params[key];
    }
  }
  if (!('userType' in params)) {
    queryString += '&userType=patient';
  }
  apiEndPoint = apiEndPoint + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function uploadDocument(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_DOCUMENTS;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function submitDocuments(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.SUBMIT_DOCUMENTS;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function deleteDocument(params, tokenData) {
  let apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_DOCUMENTS;
  apiEndPoint = apiEndPoint + `/${params.documentId}?appointmentId=${params.appointmentId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.DELETE });
}
function updateDocument(params, tokenData) {
  let apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_DOCUMENTS;
  apiEndPoint = apiEndPoint + `/${params.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: params });
}
function callPatientWaitingRoom(params, tokenData) {
  let apiEndPoint = _ApiConst.BASE_URL + _ApiConst.CALL_PATIENT_WAITING_ROOM;
  apiEndPoint = apiEndPoint + `/${params.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: params });
}
function appointmentStatus(params, tokenData) {
  // {{serverURL}}/appointment-service/Appointment?_query=getAppointmentStatus&appointmentId=61de873d2a79d9192578fe83 – GET method.
  let apiEndPoint = _ApiConst.BASE_URL + _ApiConst.APPOINTMENT_URL;
  apiEndPoint = apiEndPoint + `?_query=getAppointmentStatus&appointmentId=${params.appointmentId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function sendCallEndDuration(params, tokenData) {
  let apiEndPoint = _ApiConst.BASE_URL + _ApiConst.APPOINTMENT_URL;
  apiEndPoint = apiEndPoint + `/${params.id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: params });
}